import { PropsWithChildren } from 'react';
import { Box, Button, Card, Icon } from '@chakra-ui/react';
import { NavLink, useParams } from 'react-router-dom';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

export default function WorkspaceLayout({ children }: PropsWithChildren) {
  const { workspaceId } = useParams();

  return (
    <>
      <Card.Root
        mx={'auto'}
        width={{ md: '90%' }}
        maxW={'5xl'}
        variant={'elevated'}
        borderBottomLeftRadius={{ base: 'radii-l3', lg: 0 }}
        borderBottomRightRadius={{ base: 'radii-l3', lg: 0 }}
        bg={'bg.subtle'}
      >
        <Card.Header textAlign={'center'} pt={0} display={{ base: 'none', md: 'block' }}>
          <Button colorPalette='brand' variant={'plain'} asChild>
            <NavLink to={`/${workspaceId}/settings`}>
              <Icon as={Cog6ToothIcon} />
              Settings
            </NavLink>
          </Button>
        </Card.Header>
      </Card.Root>
      <Box flex={1}>{children}</Box>
    </>
  );
}
